import { CONSTANTS } from "../actions";

const initialState = null;

const activeBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_ACTIVE_BOARD: {
      return action.payload;
    }

    case CONSTANTS.CLEAR_APP: {
      return initialState
    }

    default:
      return state;
  }
};

export default activeBoardReducer;
